export default "__VITE_ASSET__BZgGl1aB__"